import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import OrderSignin from '@/views/OrderSignin.vue'
import UserSignin from '@/views/UserSignin.vue'
import UserList from '@/views/UserList.vue'
import UserCreate from '@/views/UserCreate.vue'
import UserEdit from '@/views/UserEdit.vue'
import OrderCreate from '@/views/OrderCreate.vue'
import OrderList from '@/views/OrderList.vue'
import OrderEdit from '@/views/OrderEdit.vue'
import OrderTransit from '@/views/OrderTransit.vue'
import UserTransit from '@/views/UserTransit.vue'
import UserSetting from '@/views/UserSetting.vue'
import Writing from '@/views/Writing.vue'
import Echarts from '@/views/Echarts.vue'
import DepartmentManagement from '@/views/DepartmentManagement.vue'
import Login from '@/views/Login.vue'
import footer from '@/components/footer.vue'

Vue.use(Router)

function requireAuth(to, from, next) {
  const role = localStorage.getItem('role');
  if (!role) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/order-signin',
      name: 'signin-order',
      component: OrderSignin,
      beforeEnter: requireAuth
    },
    {
      path: '/user-signin',
      name: 'signin-user',
      component: UserSignin,
      beforeEnter: requireAuth
    },
    {
      path: '/user/create',
      name: 'create-user',
      component: UserCreate,
      beforeEnter: requireAuth
    },
    {
      path: '/user/:id/edit',
      name: 'edit-user',
      component: UserEdit,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/user/list',
      name: 'list-user',
      component: UserList,
      beforeEnter: requireAuth
    },
    {
      path: '/echarts',
      name: 'echarts',
      component: Echarts,
      beforeEnter: requireAuth
    },
    {
      path: '/order/create',
      name: 'create-order',
      component: OrderCreate,
      beforeEnter: requireAuth
    },
    {
      path: '/order/list',
      name: 'list-order',
      component: OrderList,
      beforeEnter: requireAuth
    },
    {
      path: '/order/:id/edit',
      name: 'edit-order',
      component: OrderEdit,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/order-transit',
      name: 'transit-order',
      component: OrderTransit,
      beforeEnter: requireAuth
    },
    {
      path: '/user-transit',
      name: 'transit-user',
      component: UserTransit,
      beforeEnter: requireAuth
    },
    {
      path: '/user-setting/:id',
      name: 'user-setting',
      component: UserSetting,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/writing',
      name: 'writing',
      component: Writing,
      beforeEnter: requireAuth
    },
    {
      path: '/departmentManagement',
      name: 'departmentManagement',
      component: DepartmentManagement,
      beforeEnter: requireAuth
    },
    {
      path: '/footer',
      name: 'footer',
      component: footer,
      beforeEnter: requireAuth
    },
  ]
})